import {createAction, props} from '@ngrx/store';



export const loadContactDetails = createAction(
  '[CONTACT DETAILS] Load Contact',
  props<{ contactDetails: any }>()
);

export const loadTeamDetails = createAction(
  '[TEAM DETAILS] Load Team',
  props<{ teamDetails: any ,meta:any}>()
);

export const loadFaqDetails = createAction(
  '[FAQ DETAILS] Load Faq',
  props<{ faqDetails: any ,meta:any}>()
);

export const startCmsFetch = createAction(
  '[CMS] Fetching Start'
);

export const stopCmsFetch = createAction(
  '[CMS] Fetching Stop'
);
export const loadCareer = createAction(
  '[CAREER] Load Career',
  props<{ career: any }>()
); 


export const loadPrivacyPolicy = createAction(
  '[PRIVACY POLICY] Load Privacy Policy',
  props<{ privacyPolicy: any }>()
);

export const loadTermsCondition = createAction(
  '[TERMS AND CONDITION] Load Terms and Conditions',
  props<{ termsCondition: any }>()
);

export const loadAboutUs = createAction(
  '[ABOUT US] Load About Us',
  props<{ about: any }>()
);


export const loadSiteSetting = createAction(
  '[SITE SETTINGS] Load Site Setting',
  props<{ siteSetting: any }>()
);

export const loadBanners = createAction(
  '[BANNERS] Load Banners',
  props<{ banners: any[] }>()
);

export const loadWebBanners = createAction(
  '[WEB BANNERS] Load Web Banners',
  props<{ webBanners: any[] }>()
);

export const addBanners = createAction(
  '[BANNERS] Add Banners',
  props<{ banner: any }>()
);

export const addWebBanners = createAction(
  '[WEB BANNERS] Add Web Banners',
  props<{ webBanner: any }>()
);

export const removeBanner = createAction(
  '[BANNERS] Delete Banners',
  props<{ id: string }>()
);

export const removeWebBanner = createAction(
  '[WEB BANNERS] Delete Web Banners',
  props<{ id: string }>()
);

